import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>CMAN Details</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="cmansDetailsNumber"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>Container Number</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            @blur="$v.connumber.$touch()"
            v-model="connumber"
          />
          <p v-if="$v.connumber.$error & $v.connumber.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>Container Size and Type</span>
        </div>
        <div class="vx-col" style="width: 400px">
          <vs-select autocomplete v-model="consize" class="w-full -mt-2">
            <vs-select-item
              v-for="size in sizes"
              :key="size.code"
              :value="size.code"
              :text="size.description"
              @blur="$v.consize.$touch()"
            />
          </vs-select>
          <p v-if="$v.consize.$error & $v.consize.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>Container Status Code</span>
        </div>
        <div class="vx-col" style="width: 400px">
          <b-select placeholder="Container Status Code" v-model="constate">
            <option
              v-for="state in states"
              :value="state.code"
              :key="state.code"
              @blur="$v.constate.$touch()"
            >
              {{ state.name }}
            </option>
          </b-select>
          <p v-if="$v.constate.$error & $v.constate.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col mt-2" style="width: 230px; text-align: right">
          <span>Seal Number</span>
        </div>
        <div class="vx-col sm:w-2/5 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            v-model="sealnum"
          />
        </div>
      </div>

      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      businessPartnersCode: "",
      companyGroupsCode: "",
      userid: "",
      resback: "",
      btn_submit: "",
      btn_reset: "",
      lang_formvalid: "Please Enter Correct Information",
      add_complete: "Update Complete",
      connumber: "",
      consize: "",
      constate: "",
      sealnum: "",
      editor: "",
      readonly: true,
      states: [],
      sizes: [],
    };
  },
  validations: {
    connumber: {
      required,
    },
    consize: {
      required,
    },
    constate: {
      required,
    },
  },
  components: {
    Datepicker,
  },
  props: ["acstate", "recid", "cmansDetailsNumber", "rfcar_code"],
  methods: {
    clsd: function () {
      let vm = this;
      vm.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      // console.log(this.connumber);
      this.$v.$touch();

      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } else if (this.connumber == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: this.lang_formvalid,
        });
        return;
      } else if (
        this.rfcar_code == "1706" &&
        (this.sealnum == "" || this.sealnum == null)
      ) {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Seal Number ไม่สามารถว่างได้ หากประเภทรถคือรถตู้บรรทุกตู้สินค้า",
        });
        return;
      }

      const formData = {
        connumber: this.connumber,
        cmansDetailsNumber: this.cmansDetailsNumber,
        consize: this.consize,
        constate: this.constate,
        sealnum: this.sealnum,
        acstate: this.acstate,
        number: this.recid,
        companyGroupsCode: this.companyGroupsCode,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(formData);
      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/cmanconts/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async beforeCreate() {
    try {
      this.readonly = true;
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        searchval: "",
      };

      const response = await axios.post(
        `${BASE_API_URL}/inbound-svc/contypesize/getContypeSize`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response.data.message,
        });
      } else {
        this.sizes = response.data;
      }

      const response2 = await axios.post(
        `${BASE_API_URL}/inbound-svc/constates/getConstates`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response2.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response2.data.message,
        });
      } else {
        this.states = response2.data;
      }
    } catch (error) {
      this.data = [];
      this.total = 0;
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }
  },
  async created() {
    // console.log(this.rfcar_code);
    // console.log(this.recid);
    this.checkProfiles();

    if (this.recid != "0") {
      try {
        this.readonly = true;
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/cmanconts/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          setTimeout(() => {
            this.connumber = response.data.connumber;
            this.consize = response.data.consize;
            this.constate = response.data.constate;
            this.sealnum = response.data.sealnum;
          }, 500);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
